module.exports = __webpack_public_path__ + "media/fonts/Oricons-b1770093d098f943486778a4397cb87e.ttf";